import { api } from 'app/config/apiConfig';
import { Invoice } from 'entities/Invoice';
import { IssueUserInvoiceParams } from '../model/types';

export const issueUserInvoiceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    issueUserInvoice: builder.mutation<Invoice, IssueUserInvoiceParams>({
      query: (data) => ({
        url: `/users/${data.userId}/issue-invoice`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Invoices'],
    }),
  }),
});

export const { useIssueUserInvoiceMutation } = issueUserInvoiceApi;
